export function roundNumberWithMax2Decimals(input: number): string {
  return (Math.round((input + Number.EPSILON) * 100) / 100).toString();
}
